// @ts-nocheck
import { Box, Typography } from '@mui/material';

import { FCheckbox } from '../../../base';
import { Themes } from '../../../../constants';
import { FORTA_BLUE } from '../../../../utils/colors';
import TableSortIcon from '../../../svgs/TableSortIcon';

export const ClaimSessionTableColumns = (
  selectedAll: boolean,
  showSelectAllOption = false,
  onSelectAll: (selected: boolean) => void,
  historyClaimReviewDialogView: boolean,
  showBay = false,
  loading = false,
) => [
  {
    name: 'selected',
    options: {
      filter: false,
      sort: false,
      display: showSelectAllOption,
      customHeadLabelRender: () => (
        <FCheckbox
          sx={{ mr: 0, fontWeight: 'bold' }}
          disabled={loading}
          iconStyles={{ width: '25px', height: '25px' }}
          colorTheme={Themes.Primary}
          coloredBackground
          inputProps={{ 'data-testid': 'selectAllForClaimId' }}
          checked={selectedAll}
          onChange={(e) => onSelectAll(e.target.checked)}
        />
      ),
    },
  },
  {
    name: 'sessionStatus',
    label: 'Status',
    options: {
      filter: false,
      sort: true,
      display: !historyClaimReviewDialogView,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}
          >
            Status
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}
          >
            Date (CT)
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'id',
    label: 'id',
    options: {
      filter: false,
      sort: true,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}
          >
            Session ID
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'provider_name',
    label: 'BCBA',
    options: {
      filter: false,
      sort: true,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}
          >
            BCBA
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'status',
    label: 'Claimed',
    options: {
      filter: false,
      sort: true,
      customHeadLabelRender: () => (
        <Box sx={{ ml: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            textAlign="center"
            sx={{ mr: 1, fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}
          >
            Claimed
          </Typography>
          <TableSortIcon />
        </Box>
      ),
      display: !historyClaimReviewDialogView,
    },
  },
  {
    name: 'readonly',
    options: {
      filter: true,
      sort: false,
      display: false,
    },
  },
  {
    name: 'timeZone',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'procedureCode',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'isAwaitingFinalization',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'bay',
    label: 'Bay',
    options: {
      filter: true,
      sort: false,
      display: showBay,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ fontWeight: '700', fontSize: '16px', lineHeight: '24px' }}
          >
            Bay
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'licensed',
    label: 'Licensed',
    options: {
      filter: false,
      sort: false,
      display: !historyClaimReviewDialogView,
      customHeadLabelRender: () => (
        <Typography
          sx={{
            fontWeight: '700',
            fontSize: '16px',
            lineHeight: '24px',
            color: FORTA_BLUE.primary,
            textAlign: 'left',
          }}
        >
          Licensed
        </Typography>
      ),
    },
  },
  {
    name: 'credentialed',
    label: 'Credentialed',
    options: {
      filter: false,
      sort: false,
      display: !historyClaimReviewDialogView,
      customHeadLabelRender: () => (
        <Typography
          sx={{
            fontWeight: '700',
            textAlign: 'left',
            fontSize: '16px',
            lineHeight: '24px',
            color: FORTA_BLUE.primary,
          }}
        >
          Credentialed
        </Typography>
      ),
    },
  },
  {
    name: 'duration',
    label: 'duration',
    options: {
      filter: true,
      sort: false,
      display: !historyClaimReviewDialogView,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '16px', lineHeight: '24px' }}
          >
            Units
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'isUnderClinicalReview',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'clinical_relationship',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'session_provider',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'author_id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
];
